// gbook.js

/* eslint-disable max-len */

(function() {
  window.App = {
    Models: {},
    Collections: {},
    Views: {},
    Routes: {},
  };

  if ( typeof Backbone != 'undefined') {
    App.Routes.Gbook = Backbone.Router.extend({

      initialize: function(options) {
        this.route('page-:number', function(number) {
          pagination.current_page = number;
        } );
      },

    });

    App.Models.Gbook = Backbone.Model.extend({
      urlRoot: '/gbook/',
      idAttribute: 'entry_id',
      defaults: {
        'gbook_name': '',
        'count': '',
        'create_date': '',
        'name': '',
        'message': '',
      },
    });

    App.Collections.Gbook = Backbone.Collection.extend({
      url: '/gbook/',
      model: App.Models.Gbook,
      parse: function( response ) {
        this.trigger('gbookCollection:updated', {
          items_on_page: response.items_on_page,
          items_count: response.items_count,
          current_page: response.current_page,
        } );
        return response.items;
      },
    });

    App.Views.GbookTableRow = Backbone.View.extend({
      tagName: 'article',
      className: 'comment',
      template: _.template('<div class=\'comment-body\'><div class=\'text\'><p><%= message %></p></div><p class=\'attribution\'><%= name %> about <%= gbook_name %> at <%= create_date %></p></div>'),
      render: function() {
        var attributes = this.model.toJSON();
        this.$el.html( this.template( attributes ) );
      },
    });

    App.Views.GbookTableBody = Backbone.View.extend( {
      tagName: 'section',
      className: 'comments',
      initialize: function() {
        this.collection.on('add', this.addOne, this);
        this.collection.on('reset', this.addAll, this);
      },
      addOne: function( gbookModel ) {
        var gbookRow = new App.Views.GbookTableRow({model: gbookModel});
        gbookRow.render();
        this.$el.append( gbookRow.el );
      },
      addAll: function() {
        this.collection.forEach(this.addOne, this);
      },
      render: function() {
        this.collection.forEach(this.addOne, this);
      },
    });
  }
})();

// /////////////////////////////////////////////////////////////////////////////
// config
// /////////////////////////////////////////////////////////////////////////////

if (typeof Backbone != 'undefined') {
  var gbookCollection = new App.Collections.Gbook();

  var pagination = {
    items_on_page: 5,
    current_page: 1, // page to start at, first page is 1, not 0
    displayed_pages: 1, // max number of pages to show in the pagination (minimum allowed 3)
    edges: 1, // How many page numbers are visible at the beginning/ending of the pagination
    prev_text: '<svg><use xlink:href="#shape-left-open"></svg>',
    next_text: '<svg><use xlink:href="#shape-right-open"></svg>',
  };
}

// /////////////////////////////////////////////////////////////////////////////
// document.ready
// /////////////////////////////////////////////////////////////////////////////

$(document).ready( function() {
  if (typeof Backbone != 'undefined') {
    // var gbookRouter = new App.Routes.Gbook();

    // without history API
    Backbone.history.start();

    // get json from api
    updateGbookCollection(showGbooks);

    // when event fires, update the pagination
    gbookCollection.on('gbookCollection:updated', function( details ) {
      updatePagination( details, showGbooks );
    });

    $('.comments-container').swipe({
      swipeLeft: swipe,
      swipeRight: swipe,
      aullowPageScroll: 'auto',
    });
  }
});

// /////////////////////////////////////////////////////////////////////////////
// subroutines
// /////////////////////////////////////////////////////////////////////////////

/**
 *
 * @param {*} event
 * @param {*} direction
 */
function swipe(event, direction) {
  if (direction === 'left') {
    $('.pagination-container').pagination('prevPage');
  } else if (direction === 'right') {
    $('.pagination-container').pagination('nextPage');
  }
}

/**
 *
 * @param {*} collection
 * @param {*} response
 */
function showGbooks( collection, response ) {
  var view = new App.Views.GbookTableBody({
    collection: collection,
  });

  view.render();

  // empty comments and appedn the new results
  $('.comments-container').empty();
  // .append( view.el );
  $('.comments-container').html( view.el );
}

/**
 *
 * @param {*} successCallback
 */
function updateGbookCollection( successCallback ) {
  var data = {
    gbook_id: 1,
    items_on_page: pagination.items_on_page,
    current_page: pagination.current_page,
  };

  gbookCollection.fetch({
    data: data,
    success: successCallback,
    error: function() {
      console.log('updateGbookCollection failed');
    },
  });
}

/**
 *
 * @param {*} details
 * @param {*} successCallback
 */
function updatePagination( details, successCallback ) {
  // calculate pagination attributes
  var itemStart = (details.current_page == 1) ?
    1 : (details.current_page * pagination.items_on_page) - (pagination.items_on_page - 1);
  var itemEnd = (details.current_page * pagination.items_on_page);
  if (itemEnd > details.items_count) {
    itemEnd = details.items_count;
  }

  // $(".pagination-info").text(""+ pagination.items_on_page +" items " + itemStart + " through " + itemEnd + " of " + details.items_count );
  $('.pagination-info').text(itemStart + ' - ' + itemEnd + ' of ' + details.items_count );

  // remove pagination binding
  // so they don't get called multiple times
  $('.pagination-container').unbind();

  // itemsOnPage      : Total number of items that will be used to calculate the pages
  // current_page     : Which page will bbe selected immediattely after init
  // itemsOnPage      : Number of items displayed on each page
  // displayedPages   : How many page numbers should be visibile while navigating (minimum allowed: 3 previous, current & next)

  $('.pagination-container').pagination({
    items: details.items_count,
    currentPage: details.current_page,
    itemsOnPage: pagination.items_on_page,
    displayedPages: pagination.displayed_pages,
    ellipseText: '&bull;',
    cssStyle: 'pouakai',
    edges: pagination.edges,
    prevText: pagination.prev_text,
    nextText: pagination.next_text,
    onPageClick: function(page, event) {
      if (page) {
        pagination.current_page = page;
        updateGbookCollection( successCallback );
      }
    },

  });
}

//
// EOF
//
